



































import { Component, Prop, Vue } from 'vue-property-decorator'
import { RecommendItem } from '../../modules/silverEgg/RecommendResponse'

@Component({})
export default class RecommendApplication extends Vue {
  // -------------------------------------------------------------------------------------------------------------------
  // prop
  @Prop() private recommendItems!: RecommendItem[]

  // -------------------------------------------------------------------------------------------------------------------
  // method

  /**
   * PDFクリック処理
   */
  private select(item: RecommendItem) {
    this.$emit('select', item, 'application')
  }
}
